import { React, useState } from "react";
import Modal from "react-bootstrap/Modal";
import AOS from "aos";
import { useEffect, useRef } from "react";
import "./ModalClickStyle.css";
import { CheckCircleFill } from "react-bootstrap-icons";
import emailjs from "@emailjs/browser";

const ModalClick = ({ text }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const style = {
    inputStyle: `col-12 mt-2 rounded border-0 form-control px-3 py-2  mb-2 mb-md-1 was-validated`,
  };

  const dataStyle = {
    color: "rgba(128, 128, 128, 1)",
    padding: "0.5rem 1rem",
    fontSize: "1.1rem",
    backgroundColor: "rgba(247, 247, 247, 1)",
  };

  useEffect(() => {
    AOS.init({ duration: 1500 });
  }, []);

  const form = useRef();
  const [validation, setValidation] = useState(false);
  //   const [closeNotification, setCloseNotification] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_6eavg89",
        "template_eg8bzsj",
        form.current,
        "4CsIOrBL6Z1eB9p4O"
      )
      .then(
        (result) => {
          console.log(result.text);

          if (result.status === 200) {
            setValidation(!validation);
            // setCloseNotification(!closeNotification);
            setTimeout(() => {
              handleClose();
              setValidation(validation);
            }, 1500);
          }
        },
        (error) => {
          console.log(error.text);
        }
      );

    e.target.reset();
  };
  return (
    <>
      <span onClick={handleShow}>{text}</span>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="border-0">
          <Modal.Title className="fs-2 fw-bold text-center w-100">
            <div className="text-center">Request a Demo</div>
          </Modal.Title>
        </Modal.Header>
        <div className="text-center mt-2" style={{ fontSize: "0.8rem" }}>
          Please Fill in Your Information Below
        </div>
        <Modal.Body>
          <form
            ref={form}
            className="container p-md-3 mx-auto needs-validation"
            onSubmit={sendEmail}
          >
            <div className="row">
              <div className="form-group">
                <input
                  className={style.inputStyle}
                  type="text"
                  required
                  style={dataStyle}
                  placeholder="Name"
                  name="user_name"
                />
                <input
                  className={style.inputStyle}
                  type="text"
                  style={dataStyle}
                  required
                  placeholder="Phone Number"
                  name="user_phone"
                />

                <input
                  className={style.inputStyle}
                  type="email"
                  style={dataStyle}
                  required
                  placeholder="Email"
                  name="user_email"
                />
                <input
                  className={style.inputStyle}
                  type="text"
                  style={dataStyle}
                  required
                  placeholder="Company Name"
                  name="user_company"
                />
              </div>

              <div className="form-group mt-1 mb-3">
                <button
                  className="btn my-2 mx-auto border-0 w-100 fs-5"
                  style={{
                    backgroundColor: "rgba(40, 182, 114, 1)",
                    color: "white",
                    fontSize: "1.07rem",
                  }}
                  onSubmit={sendEmail}
                >
                  Submit
                </button>
                <button
                  className="btn mx-auto border-0 w-100 fs-5"
                  style={{
                    borderStyle: "solid",
                    borderColor: "green",
                    borderWidth: "1rem",
                    backgroundColor: "rgba(247, 247, 247, 1)",
                    color: "rgba(40, 182, 114, 1)",
                    fontSize: "1.07rem",
                  }}
                  onClick={handleClose}
                >
                  Close
                </button>
              </div>

              <div className="modalValidation">
                {validation && (
                  <div className="modalSuccess">
                    <div className="bg-light d-flex justify-content-center py-2 px-3 mt-2 rounded align-items-center">
                      <div className="px-2">
                        <CheckCircleFill />
                      </div>
                      <small>Form Submitted</small>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ModalClick;
